
const pushList = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 80,
        scopedSlots: { customRender: 'index' },
        ellipsis: true,
    },
    {
        title: '推送名称',
        dataIndex: 'name',
        width: 200,
        scopedSlots: { customRender: 'name' },
        ellipsis: true,
    },
    {
        title: '推送时间',
        dataIndex: 'startTime',
        scopedSlots: { customRender: 'startTime' },
    },
    {
        title: '任务完成时间',
        dataIndex: 'finishTime',
        scopedSlots: { customRender: 'finishTime' },
    },
    {
        title: '推送人数',
        dataIndex: 'finishPushCount',
    },
    {
        title: '推送状态',
        dataIndex: 'status',
        scopedSlots: { customRender: 'pushStatus' },
    },
    {
        title: '操作',
        dataIndex: 'operation',
        width: 150,
        scopedSlots: { customRender: 'operation' },
        ellipsis: true,
    }
];
const listStudentColumns = [
    {
        title: '姓名',
        dataIndex: 'memberFullName',
        width: 200,
        scopedSlots: { customRender: 'memberFullName' },
        ellipsis: true,
    },
    {
        title: '账号',
        dataIndex: 'memberName',
        width: 150,
        scopedSlots: { customRender: 'memberName' },
        ellipsis: true,
    },
    {
        title: '性别',
        dataIndex: 'sex',
        scopedSlots: { customRender: 'sexmap' },
        width: 100,
        ellipsis: true,
    },
    {
        title: '岗位',
        dataIndex: 'positionName',
        width: 150,
        scopedSlots: { customRender: 'positionName' },
        ellipsis: true,
    },
    {
        title: '职务',
        dataIndex: 'jobName',
        width: 150,
        scopedSlots: { customRender: 'jobName' },
        ellipsis: true,
    },
    {
        title: '归属部门',
        dataIndex: 'organizationName',
        width: 200,
        scopedSlots: { customRender: 'organizationName' },
        ellipsis: true,
    }
];

const listContentColumns = [
    {
        title: '课程名称',
        dataIndex: 'name',
        width: 200,
        scopedSlots: { customRender: 'contentName' },
        ellipsis: true,
    },
    {
        title: '归属部门',
        dataIndex: 'organization.name',
        width: 200,
        scopedSlots: { customRender: 'dep' },
        ellipsis: true,
    },
    {
        title: '课程目录',
        dataIndex: 'category.pathName',
        width: 200,
        ellipsis: true,
    },
    {
        title: '适用终端',
        dataIndex: 'publishClient',
        width: 100,
        scopedSlots: { customRender: 'publishClient' },
        ellipsis: true,
    }
];
const subjectListContentColumns = [
    {
        title: '专题名称',
        dataIndex: 'name',
        width: 200,
        scopedSlots: { customRender: 'subjectContentName' },
        ellipsis: true,
    },
    {
        title: '归属部门',
        dataIndex: 'organization.name',
        width: 200,
        scopedSlots: { customRender: 'dep' },
        ellipsis: true,
    },
    {
        title: '类型',
        dataIndex: 'subjectType',
        scopedSlots: { customRender: 'subjectType' },
    },
    {
        title: '适用终端',
        dataIndex: 'publishClient',
        scopedSlots: { customRender: 'publishClient' },
    }
];

const pushListDetail = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 80,
        scopedSlots: { customRender: 'index' },
        ellipsis: true,
    },
    {
        title: '姓名',
        dataIndex: 'pushMember.fullName',
        width: 200,
        scopedSlots: { customRender: 'pushMemberFullName' },
        ellipsis: true,
    },
    {
        title: '账号',
        dataIndex: 'pushMember.name',
        width: 150,
        scopedSlots: { customRender: 'pushMemberName' },
        ellipsis: true,
    },
    {
        title: '归属部门',
        dataIndex: 'pushMember.organization.name',
        width: 200,
        scopedSlots: { customRender: 'pushMemberOrganizationName' },
        ellipsis: true,
    },
    {
        title: '推送状态',
        dataIndex: 'pushStatus',
        scopedSlots: { customRender: 'pushStatus' },
    },
    {
        title: '任务完成状态',
        dataIndex: 'taskStatus',
        scopedSlots: { customRender: 'taskStatus' },
    },
    {
        title: '操作',
        scopedSlots: { customRender: 'operation' },
    }
];
const pushListDetailRecord = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 80,
        scopedSlots: { customRender: 'index' },
        ellipsis: true,
    },
    {
        title: '业务名称',
        dataIndex: 'businessName',
        width: 200,
        scopedSlots: { customRender: 'businessName' },
        ellipsis: true,
    },
    {
        title: '业务类型',
        dataIndex: 'businessType',
        scopedSlots: { customRender: 'businessType' },
    },
    {
        title: '推送时间',
        dataIndex: 'pushTime',
        scopedSlots: { customRender: 'pushTime' },
    },
    {
        title: '推送前已注册',
        dataIndex: 'courseRegister.isRegister',
        scopedSlots: { customRender: 'isRegister' },
    },
    {
        title: '学习状态',
        dataIndex: 'courseStudyProgress.finishStatus',
        scopedSlots: { customRender: 'courseStudyFinishStatus' },
    }
];

const contentList = [
    {
        title: '序号',
        dataIndex: 'index',
        width: 80,
        scopedSlots: { customRender: 'index' },
        ellipsis: true,
    },
    {
        title: '名称',
        dataIndex: 'businessName',
        width: 200,
        scopedSlots: { customRender: 'cBusinessName' },
        ellipsis: true,
    },
    {
        title: '业务类型',
        dataIndex: 'businessType',
        scopedSlots: { customRender: 'businessType' },
    },
    {
        title: '选/必修',
        dataIndex: 'isRequired',
        scopedSlots: { customRender: 'selectStudy' },
    },
    {
        title: '操作',
        scopedSlots: { customRender: 'operation' },
    }
];

export default {
    pushList,
    pushListDetail,
    pushListDetailRecord,
    1: listContentColumns,
    2: subjectListContentColumns,
    3: listStudentColumns,
    contentList
};
